// extracted by mini-css-extract-plugin
export default {"mainContainer":"Events_mainContainer__r6wtb","loadMoreButton":"Events_loadMoreButton__JsEsO"};